import React, { useEffect, useState } from 'react'
import styles from "./style.module.css"
import { Tabs, TabList, TabPanels, Tab, TabPanel, InputGroup, Input, InputRightElement, Button } from '@chakra-ui/react'
import { BiFilter, BiSearch } from 'react-icons/bi'
import Upcoming from './Upcoming/Upcoming'


import CreateNotification from './CreateNotification/CreateNotification'
import ContactPartner from './ContactPartner/CreateMassage/ContactPartner'
import { useDispatch, useSelector } from 'react-redux'
import { fetchNotificationData } from '../../Redux/PushNotification/NotificationReducer'
import Filter from './Filter'
import Pending from './Pending/Pending'
import Previous from './Previous/Previous'
const PushNotification = () => {
  const [create, setCreate] = useState(false)
  const [contact, setContact] = useState(false)
  const [type, setType] = useState("Overview")
  const [search, setSearch] = useState()
  const [page, setpage] = useState(1)
  const dispatch = useDispatch()
  const notification = useSelector(store => store.NotificationReducer.Notification.data) || []
  const { pendingCount, historyCount, overViewCount } = useSelector(store => store.NotificationReducer.Notification)
  const partnerId = JSON.parse(localStorage.getItem("userId"))
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [filterApplied, setFilterApplied] = useState(false)




  useEffect(() => {
    
    dispatch(fetchNotificationData(type, search, page, partnerId, startDate, endDate))
  }, [page, search, type, dispatch, partnerId, filterApplied])

  if (create) {
    return (
      <CreateNotification setCreate={setCreate} />
    )
  }
  if (contact) {
    return (
      <ContactPartner setContact={setContact} />
    )
  }

  return (
    <div className={styles.MainContainer}>

      <div className={styles.firstDiv}>
        <h1>Push Notification</h1>

        <div className={styles.filterDiv}>
          <InputGroup w={200}>
            <Input placeholder='Search' onChange={(e) => setSearch(e.target.value)} />
            <InputRightElement>
              <BiSearch color='green.500' />
            </InputRightElement>
          </InputGroup>
          <Filter setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} setFilterApplied={setFilterApplied} filterApplied={filterApplied} />

          <Button bg="#8CC9E9" onClick={() => setCreate(true)}>Create New Notification</Button>
        </div>

      </div>
      <div>
        <Tabs>
          <TabList>
            <Tab className={styles.tabPanel} onClick={() => setType("Overview")}>Upcoming <span id={type === "Overview" ? styles.activeTab : null} className={styles.numberSpan}>{overViewCount}</span></Tab>
            &nbsp;
            &nbsp;
            &nbsp;

            <Tab className={styles.tabPanel} onClick={() => setType("Pending")}>Pending <span id={type === "Pending" ? styles.activeTab : null} className={styles.numberSpan}>{pendingCount}</span></Tab>
            &nbsp;
            &nbsp;
            &nbsp;

            <Tab className={styles.tabPanel} onClick={() => setType("History")}>Previous <span id={type === "History" ? styles.activeTab : null} className={styles.numberSpan}>{historyCount}</span></Tab>

          </TabList>

          <TabPanels>
            <TabPanel>
              <Upcoming notification={notification} />
            </TabPanel>
            <TabPanel>
              <Pending notification={notification} setContact={setContact} setCreate={setCreate} />
            </TabPanel>
            <TabPanel>
              <Previous notification={notification} />
            </TabPanel>


          </TabPanels>
        </Tabs>
      </div>
    </div>
  )
}

export default PushNotification